import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from './context/AppContext';
import App from './App';
import ReportPage from './views/ReportPage';
import PublicAuditView from './views/PublicAuditView';
import Spalah360Result from './views/Spalah360Result';
import ClientCabinetView from './views/ClientCabinetView';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("ErrorBoundary caught:", error, info); }
  render() {
    if (this.state.error) return <div style={{ padding: 40, fontFamily: "monospace" }}><h2 style={{ color: "red" }}>Error</h2><pre>{this.state.error.toString()}{"\n\n"}{this.state.error.stack}</pre><button onClick={() => this.setState({ error: null })} style={{ marginTop: 16, padding: "8px 16px", fontSize: 14 }}>Спробувати знову</button></div>;
    return this.props.children;
  }
}

const reportMatch = window.location.pathname.match(/^\/report\/([a-f0-9]+)$/);
const auditMatch = window.location.pathname.match(/^\/audit\/([a-f0-9]+)$/);
// /360 served by Express (static HTML from public/360/index.html), not React.
const s360ResultMatch = window.location.pathname.match(/^\/360\/r\/([a-f0-9]{48})\/?$/);
const cabinetMatch = window.location.pathname.match(/^\/cabinet\/([a-z0-9_-]+)\/?$/i);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary>
    {reportMatch
      ? <ReportPage />
      : auditMatch
        ? <PublicAuditView token={auditMatch[1]} />
        : s360ResultMatch
          ? <Spalah360Result token={s360ResultMatch[1]} />
          : cabinetMatch
            ? <ReportPage />
          : <AppProvider><App /></AppProvider>}
  </ErrorBoundary>
);
